import './PublicConsultationsListingBody.less';

import PropTypes from 'prop-types';

import { PublicConsultation } from '../../BlockTemplates/Listing/Specific/Views/PublicConsultation';
import SectionSubtitleView from '../SectionSubtitle/SectionSubtitleView';

const PublicConsultationsListingBody = ({
  isEditMode,
  publicConsultations = {},
}) => {
  const {
    loading = false,
    error = null,
    abertas = [],
    encerradas = [],
    loaded = false,
  } = publicConsultations;

  const shouldShowEmptyMessage =
    !loading &&
    loaded &&
    !error &&
    abertas.length === 0 &&
    encerradas.length === 0;

  const renderConsultationItem = (item, index, isLastItem = false) => {
    const itemId = item?.id ? String(item.id) : `consultation-${index}`;
    const listingItem = {
      '@id': item?.url,
      title: item?.titulo,
      description: item?.descricao,
      data_inicio: item?.data_inicio,
      data_fim: item?.data_fim,
    };

    return (
      <div
        className={`br-item py-3 px-0 b-0 ${isLastItem ? '' : 'border-bottom'}`}
        key={`${item.url}-${index}`}
      >
        <PublicConsultation
          key={itemId}
          item={listingItem}
          isEditMode={isEditMode}
        />
      </div>
    );
  };

  return (
    <div className="mb-4">
      {isEditMode ? (
        <div className="text-danger text-center my-5">
          Modo de edição: as consultas públicas não são exibidas. Salve para
          ver.
        </div>
      ) : null}

      {!isEditMode && error ? (
        <div className="text-center my-5">
          Não foi possível carregar as consultas públicas no momento.
        </div>
      ) : null}

      {loading ? (
        <div className="text-center my-5">
          <span className="fa-solid fa-spinner fa-spin" />
          <span> Carregando consultas públicas...</span>
        </div>
      ) : null}

      {!isEditMode && (abertas.length > 0 || encerradas.length > 0) ? (
        <div className="public-consultations-listing-grid">
          <div className="public-consultations-listing-open-column">
            <SectionSubtitleView data={{ subtitle: 'Em aberto' }} />
            {abertas.map((item, index) =>
              renderConsultationItem(item, index, index === abertas.length - 1),
            )}
          </div>

          <div className="public-consultations-listing-closed-column">
            <SectionSubtitleView data={{ subtitle: 'Encerradas' }} />
            {encerradas.map((item, index) =>
              renderConsultationItem(
                item,
                abertas.length + index,
                index === encerradas.length - 1,
              ),
            )}
          </div>
        </div>
      ) : null}

      {!isEditMode && shouldShowEmptyMessage ? (
        <p className="mb-0 text-muted">
          Nenhuma consulta pública foi encontrada.
        </p>
      ) : null}
    </div>
  );
};

PublicConsultationsListingBody.propTypes = {
  isEditMode: PropTypes.bool,
  publicConsultations: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.any,
    abertas: PropTypes.arrayOf(PropTypes.object),
    encerradas: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default PublicConsultationsListingBody;
